/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BEM } from "@adapptio/lib-components";
import React from "react";
import { TReferenceData } from "../../ReferenceGuideTypes";
import { NavLink } from "./NavLink";

export interface IChildNavProps {
	index: number;
	data: TReferenceData[];
	selected: TReferenceData;
	handle: (e: any, item: TReferenceData) => void;
	activeParent: number[];
	label?: string;
}

export const ChildNav: React.FC<IChildNavProps> = ({
	index,
	data,
	handle,
	selected,
	label,
	activeParent
}) => {
	const baseClass = BEM("edt-reference-sidebar-nav");

	const handleClick = (e, item) => {
		e.preventDefault();
		handle(e, item);
	};

	return (
		<ul
			className={baseClass
				.element("child-item-wrap", { active: activeParent.indexOf(index) >= 0 })
				.toClassName()}
		>
			{data.map((itemChild: TReferenceData, indexChild: number) => {
				if (!itemChild?.hidden) {
					return (
						<li
							key={indexChild}
							className={baseClass
								.element("child-item", { active: selected.label === itemChild.label })
								.toClassName()}
						>
							<NavLink
								handle={handleClick}
								index={indexChild}
								item={itemChild}
								label={label ? label : itemChild.label}
								// descriptor={itemChild.getTypeDescriptor ? itemChild.getTypeDescriptor() : null}
							/>
						</li>
					);
				} else {
					return null;
				}
			})}
		</ul>
	);
};
